import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import * as moment from 'moment';
import { AppState } from '../../app.service';
import { Path } from '../../path/path-v2.model';
import { PathRegistration } from 'src/app/user/path-registration.model';
import { Poll } from 'src/app/poll/poll.model';
import { ContentSurvey } from 'src/app/content-survey/content-survey.model';
import { Question } from 'src/app/question/question.model';
import { Habit } from 'src/app/habit/habit.model';
import { Document } from 'src/app/document/document.model';
import { User } from 'src/app/user/user.model';
import { RoutineService } from 'src/app/daily-content-v2/routine.service';
import mixpanel from 'mixpanel-browser';
declare var require: any

@Injectable()
export class HomeV5Service {

  intro:any
  API_URL: string = environment.apiBaseUrl
  UPDATE_SCHEDULEDAY = '/users/update_schedule_day'
  COMMUNITY_FEEDS = '/getAllData'
  post_comments = "/get_posts"
  post_comments_v2 ='/get_posts_v2'
  post_comments_kyper='/get_kyper_posts'
  feedback = '/users/rate_app'
  list_subpath = '/users/path_list'
  change_subpath = '/users/update_path'
  setOnboardingCompleted = '/users/set_onboarding'
  accoutablity_email = '/users/accountability_email'
  userFeedback = '/createFeedbacks'
  path: any;
  calendarData: any
  stepFeedback = '/createStepRatings'
  DISABLE_NOTIFICATION = '/set_notification'
  kyperHabitNotificationDisable ='/set_habit_notification'
  ROUTINE_UPDATE_DATA = '/routineUpdateData'
  dailySteps = []
  poll: Poll
  survey: ContentSurvey
  document: Document
  question: Question
  habit: Habit
  dailyStepsArray;

  constructor(private httpclient: HttpClient,
    private appState: AppState,
    private routineService: RoutineService) {
    this.path = this.appState.get('currentPath')
    this.dailyStepsArray= this.appState.get("DailyStepsData");
   }


  public updateScheduleDay(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    // The active cycle travels with every schedule-day write. Added here rather than at the eight
    // call sites: a field added per caller is a field one caller ends up missing, which is exactly
    // what happened with the step-start API. A caller that supplies its own path_id still wins, so
    // a deliberate write against another cycle keeps working.
    const payload = { ...data, path_id: data?.path_id ?? this.appState.get('currentPath')?.id ?? null };
    return this.httpclient.put(this.API_URL+this.UPDATE_SCHEDULEDAY,payload,{headers});
  }

  public giveFeedback(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.httpclient.put(this.API_URL+this.feedback,data,{headers})
  }


  public getSubPathList(data: any): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.put(this.API_URL+this.list_subpath,data,{headers})
  }


  /**
   * Step state that belongs to a path but is stored in global slots.
   *
   * Runs here rather than at a caller: the all-cycles screen clears most of this for its own switch,
   * but there are eleven entry points and nine of them never cleaned up at all. Left behind, these
   * are read against the path just switched to — and the guards that read them compare step
   * POSITIONS, which both paths have and which readily coincide.
   *
   * Scope: the screen-progress working set ONLY. It is re-derived on the next screen change, and every
   * reader guards it with a path stamp, so clearing it costs nothing and can strand nobody.
   *
   * Deliberately NOT cleared, each for a reason that bites:
   *
   * - `currentPath` — every screen dereferences it; a caller that stays put would break before the
   *   new path arrives.
   * - `DailyStepsData`, `currentChapterInfo`, `dailyStreaksInfo`, `daysOfContent`,
   *   `totalDayOfContent`, `allContentCompleted` — the in-step and end-of-step screens read these
   *   ONCE, as they are constructed, and subscribe to nothing that would rebuild them. A caller that
   *   navigates straight into a step after switching — commitments and the to-do list both do, for a
   *   habit level that lives in another cycle — would construct against nothing and render a blank
   *   step, with no recovery. Stale data here is handled at the point of USE by the path stamps,
   *   not by blanking it.
   * - the step pointer (`reviewingStepIndex`, `currentActiveChapter`, `currentActiveStepIndex`,
   *   `currentScheduleDay`, `scheduleDayForCurrentStep`) and the level working state
   *   (`levelUpdated`, `levelUpdateData`, `levelSaveData`, `indexOfLevel`, `showUpdatedScreens`) —
   *   callers SET these before switching, as intent for the destination cycle. Clearing them would
   *   wipe that intent mid-flight.
   *
   * The all-cycles screen still clears the wider set for its own switch, which is safe there: it
   * navigates to home and waits for a full refresh, with no step or level in hand.
   *
   * Every reader also checks a path stamp (UtilityService), so this is the tidy-up, not the defence:
   * a key missed here, or a switch that errored before reaching it, is inert rather than harmful.
   */
  private clearPreviousPathStepState() {
    [
      // Screen progress taken on the old path.
      'currentScreenIndexAfterScreenView', 'currentDayAfterScreenView', 'screensIdsAfterScreenView',
      'screenPositionPathId', 'stepObject', 'stepObjectPathId', 'stepsArray', 'screensViewed',
      'screensViewedPathId', 'screenStatus',
      // The chapter order the learner personalised ON THE OLD CYCLE. Your Path shows every chapter
      // when this says personalisation is finalised, so carrying it across a switch made an
      // unstarted cycle render all its chapters and treat its opt-in as already done. It is
      // refetched per cycle, so dropping it just means the new cycle decides for itself.
      'userShuffledChapters',
    ].forEach(key => this.appState.set(key, undefined))
    try {
      [
        'currentScreenIndexAfterScreenView', 'currentDayAfterScreenView', 'screensIdsAfterScreenView',
        'screenPositionPathId', 'screenStatus', 'stepsCompleted', 'stepCompleted', 'isBeginClicked',
      ].forEach(key => localStorage.removeItem(key))
    } catch (e) { /* storage unavailable; the appState clear above still holds */ }
  }

  /**
   * Every cycle switch in the app goes through here, so the event lives here rather than being
   * repeated at each caller — only the section name differs, and that is what `source` carries.
   *
   * @param source the section the switch was started from, for the Mixpanel event.
   */
  public subpathchange(data:any, source: string = 'Unknown'):Observable<any>{
    const from = this.appState.get('currentPath')
    // Read now, sent later: the switch replaces currentPath, so the "from" side of the event has to
    // be captured before the request even though the event itself only goes once it has succeeded.
    const switchInfo = {
      source,
      fromPathId: from?.id ?? null,
      fromPathName: from?.name ?? null,
      toPathId: data?.active_path_id ?? null,
      userId: data?.user_id ?? this.appState.get('currentUser')?.id ?? null,
    }
    this.appState.set('toDos', undefined)
    this.appState.set('loggedInDates', undefined)
    this.routineService.getTodoList(this.path?.id)
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));
    return this.httpclient.put(this.API_URL+this.change_subpath,data,{headers}).pipe(
      // Only once the switch has actually happened. Clearing before the call would strand a learner
      // whose switch FAILED on the path they are still on, with its step state wiped. A switch that
      // errors therefore leaves the old state in place — harmless, because every reader checks the
      // path stamp (UtilityService) and ignores a reading from another cycle.
      tap(() => {
        this.clearPreviousPathStepState()
        this.appState.set('npsSelections', undefined)
        // Sent from here, not from the top of the method: the PUT runs only when a caller
        // subscribes, so an event raised up there counted attempts — including failed ones — as
        // switches that happened.
        mixpanel.track('Cycle switched', switchInfo)
      }, (error) => {
        // Failures stay visible; moving the event into the success path would otherwise hide them.
        mixpanel.track('Cycle switch failed', { ...switchInfo, status: error?.status ?? null })
      })
    );
  }


  public onbordingCompleted(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.put(this.API_URL+this.setOnboardingCompleted,data,{headers})
  }

  public accountablityEmailAPI(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.put(this.API_URL+this.accoutablity_email,data,{headers})
  }

  public supportFeedback(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));
    return this.httpclient.post(this.API_URL + this.userFeedback, data,{headers})
  }

  public postStepFeedback(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));
    return this.httpclient.post(this.API_URL + this.stepFeedback, data,{headers})
  }

  public routineUpdateData(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));
    return this.httpclient.post(this.API_URL + this.ROUTINE_UPDATE_DATA, data,{headers});
  }

  public getListOfFeeds(data,userId,isTranslate,language,page): Observable<any>{
    const headers = new HttpHeaders();
     headers.set("Authorization", localStorage.getItem("token"));
    const params = new HttpParams()
    .append('id', data)
    .append('user_id',userId)
    .append('is_translate',isTranslate)
    .append('language',language)
    .append('page',page);
    
    return this.httpclient.get(this.API_URL+this.COMMUNITY_FEEDS,{headers,params});
  }

  public getListOfComments(data,userId,isTranslate,language,page): Observable<any>{
    const headers = new HttpHeaders();
     headers.set("Authorization", localStorage.getItem("token"));
    const params = new HttpParams()
    .append('id', data)
    .append('user_id',userId)
    .append('is_translate',isTranslate)
    .append('language',language)
    .append('page',page);
    
    return this.httpclient.get(this.API_URL+this.post_comments,{headers,params});
  }
   public getListOfComments_v2(data,isTranslate,language,page): Observable<any>{
     const headers = new HttpHeaders();
     isTranslate = this.appState.get('selectedLanguage') ? true : false
     language = this.appState.get('selectedLanguage') ? this.appState.get('selectedLanguage') : null
     headers.set("Authorization", localStorage.getItem("token"));
    const params = new HttpParams()
    .append('id', data)
    .append('is_translate',isTranslate)
    .append('language',language)
    .append('page',page);
    
    return this.httpclient.get(this.API_URL+this.post_comments_kyper,{headers,params});
  }
  
  findForDay(collection: any,day_number): any {
    return collection.find(
      item => item.startDay <= day_number && day_number <= item.endDay
    )
  }

  getHabitByActiveDay(day_number:any,path:Path){
    var closeTime = null
    var timeArray = []
    try{

      const getCorrectTimeObject = (data) => {
      if(data && data.time){
        return timeArray.push(data.time) 
      }
    }
    this.dailyStepsArray= this.appState.get("DailyStepsData");
    var habitAction = this.dailyStepsArray[day_number-1]?.habits
      getCorrectTimeObject(habitAction)
    
    var poll = this.dailyStepsArray[day_number-1]?.polls
      getCorrectTimeObject(poll)
    
    var document = this.dailyStepsArray[day_number-1]?.documents
      getCorrectTimeObject(document)
    
    var question = this.dailyStepsArray[day_number-1]?.questions
      getCorrectTimeObject(question)
     
    var temp = timeArray[0]
      timeArray.forEach(element => {
        if(moment(temp).isBefore(element)){
          temp = element
        }
        closeTime = temp;
      });
    }catch(o_O){
        console.log("error",o_O);
    }
    if(!closeTime){
      return ''
    }else{
      return closeTime
    }
    
  }


  findById(arrayOfData,id){
    var data = arrayOfData.find( item => item.id === id)
    return data
  }


  getCalendarData(){
    return this.calendarData
  }


  setCalendarData(data){
    this.calendarData = data
    return this.calendarData
  }

  
  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};
    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
  }

  animateActionPoints(points, start, end, duration){
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      points.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
    this.appState.set('PreviousPoints',end)
  }

  public disableNotification(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.post(this.API_URL + this.kyperHabitNotificationDisable, data,{headers});
  }

  checkScreenCount(pathRegistration: PathRegistration, scheduleDay: number): boolean {
    let screensViewed = this.appState.get('screensViewed')
    let stepsArray = []
    let showContinueButton: boolean
    if (screensViewed && (pathRegistration?.screensViewed ==null || pathRegistration?.screensViewed?.length== screensViewed?.length)) {
      let steps = screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    } else {
      let steps = pathRegistration?.screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    }
    if (stepsArray?.length > 0) {
      stepsArray.forEach(element => {
        if (element.step === scheduleDay && element.visitedScreens < element.totalScreens) {
          showContinueButton = true
        }
      });
      return showContinueButton
    }
    return false
  }

  getDailySteps(currentDay: number, path: Path){
    this.dailyStepsArray= this.appState.get("DailyStepsData");
    this.poll = this.dailyStepsArray[currentDay-1]?.polls
    this.survey = this.dailyStepsArray[currentDay-1]?.contentSurveys
    this.document = this.dailyStepsArray[currentDay-1]?.documents
    this.question = this.dailyStepsArray[currentDay-1]?.questions
    this.habit = this.dailyStepsArray[currentDay-1]?.habits

    this.dailySteps = [
      {
        kind: 'poll',
        title: 'h_ds_p',
        icon: 'glyphicon glyphicon-question-sign'
      },
      {
        kind: 'document',
        title: 'h_ds_d',
        icon: 'glyphicon glyphicon-list'
      },
      {
        kind: 'question',
        title: 'h_ds_q',
        icon: 'glyphicon glyphicon-comment'
      },
      {
        kind: 'survey',
        title: 'h_ds_s',
        icon: 'glyphicon glyphicon-comment'
      },
      {
        kind: 'habit',
        title: 'h_ds_h',
        icon: 'glyphicon glyphicon glyphicon-list'
      }
    ]
    this.dailySteps.forEach(s => this.fillParams(s))
    this.dailySteps.sort((a, b) => a.order - b.order)
  }

  fillParams(item: any) {
    const source = this[item.kind]
    if (source) {
      item.exists = true
      item.isCompleted = source.isCompleted
      item.order = source.screenOrder
      item.isMandatory = source.isMandatory
      item.actionPoints = source.actionPoints ? source.actionPoints : source.answer ? source.answer.actionPoints : 0
      item.screenId = `daily-content-screen-${item.kind}`
    } else {
      item.exists = false
      item.isCompleted = false
      item.isMandatory = false
      item.order = 0
      item.actionPoints = 0
    }
    return item
  }

  checkAllNonMandatory(): boolean {    
    let isNonMandatoryArray = this.dailySteps.filter(s => s.exists && !s.isMandatory);
    let isAllTaskArray = this.dailySteps.filter(s => s.exists);
    let isAllNonMandatory: boolean = false

    if (isNonMandatoryArray.length == isAllTaskArray.length) {
      isAllNonMandatory = true
    } 
    return isAllNonMandatory
  }

  findForCurrentDay(collection: any, currentDay: number): any {
    return collection.find(item => item.startDay <= currentDay && currentDay <= item.endDay)
  }

  checkPrevDayCompletedForNonMand(pathRegistration: PathRegistration, scheduleDay: number, currentUser: User, currentPath: Path, currentDayStarted: boolean): boolean {
    let showBeginButton: boolean
    if (scheduleDay === 1 && !currentDayStarted) {
      showBeginButton = true
      return showBeginButton
    }
    let stepsArray = []
    let screensViewed = this.appState.get('screensViewed')
    if (screensViewed) {
      let steps = screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    } else {
      let steps = pathRegistration?.screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    }
    return false
  }

  checkPrevDayCompleted(pathRegistration: PathRegistration, scheduleDay: number, currentUser: User, currentPath: Path): boolean {
    let showPrevButton: boolean
    let stepsArray = []
    let screensViewed = this.appState.get('screensViewed')
    if (screensViewed) {
      let steps = screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    } else {
      let steps = pathRegistration?.screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    }    
    if (stepsArray?.length > 0) {
      stepsArray.forEach(element => {
        if (element.step === scheduleDay && element.visitedScreens === element.totalScreens) {
          // localStorage.setItem(`Toggle:User:${currentUser.id}:DayUnlockCompleted:${currentPath.id}:${scheduleDay - 1}`, 'yes') 
          showPrevButton = true
        }
      });
      return showPrevButton
    }
    return false
  }

  checkReplayForNonMand(pathRegistration: PathRegistration, scheduleDay: number): boolean {
    let screensViewed = this.appState.get('screensViewed')
    let stepsArray = []
    let showReplayButton: boolean
    if (screensViewed) {
      let steps = screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    } else {
      let steps = pathRegistration?.screensViewed
      stepsArray = this.removeDuplicates(steps, "step");
    }
    if (stepsArray?.length > 0) {
      stepsArray.forEach(element => {
        if (element.step === scheduleDay && element.visitedScreens === element.totalScreens) {
          showReplayButton = true
        }
      });
      return showReplayButton
    }
    return false
  }

}
